import { useSelector } from "react-redux";
import { selectIsFeatureFlagEnabled } from "slices/featureFlags";

const useFeatureFlag = (flagName) =>
  useSelector(selectIsFeatureFlagEnabled(flagName));

export default useFeatureFlag;
